import { BackendService } from './backend.service';
import { UserService } from './user.service';
var ReminderService = (function () {
    function ReminderService(backendService, userService) {
        var _this = this;
        this.backendService = backendService;
        this.userService = userService;
        /** Array containing all user created Programs */
        this.allMyReminders = { defaultReminder: null, reminders: [] };
        /** Store the current user */
        this.user = null;
        this.userService.currentUser.subscribe(function (user) {
            if (!user) {
                return;
            }
            _this.user = user;
        });
    }
    ReminderService.prototype.getMyReminders = function () {
        var _this = this;
        // load from server
        return this.backendService.get('reminder').then(function (data) {
            _this.allMyReminders = data;
            _this.allMyReminders.reminders.sort(function (a, b) {
                return b.time.hours === a.time.hours ? a.time.minutes - b.time.minutes : a.time.hours - b.time.hours;
            });
            return _this.allMyReminders;
        });
    };
    ReminderService.prototype.saveNewReminder = function (reminder) {
        var _this = this;
        return this.backendService.post("reminder", reminder).then(function () { return _this.getMyReminders(); });
    };
    ReminderService.prototype.updateMyReminder = function (reminder) {
        var _this = this;
        return this.backendService.put("reminder/" + reminder._id + "/", reminder).then(function () { return _this.getMyReminders(); });
    };
    ReminderService.prototype.deleteMyReminder = function (reminder) {
        var _this = this;
        return this.backendService
            .delete_("reminder/" + reminder._id + "/")
            .then(function () { return _this.getMyReminders(); })
            .catch(function () { });
    };
    ReminderService.prototype.setReminderPause = function (isPaused, dateRange) {
        return this.backendService.put("user/me", {
            reminderPause: {
                isPaused: isPaused,
                dateRange: dateRange,
            },
        });
    };
    ReminderService.prototype.getReminderPause = function () {
        return this.backendService.get('user/me').then(function (result) {
            return {
                isPaused: result.reminderPause.isPaused,
                dateRange: result.reminderPause.dateRange,
            };
        });
    };
    return ReminderService;
}());
export { ReminderService };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/reminder.service.ts.pre-build-optimizer.js